module.exports = __webpack_public_path__ + "static/media/hand_blue.ecb930bc.svg";